import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DownloadStatementFormOptions } from "../../interfaces";

/**
 * Creates a feature selector for the 'DownloadStatementForm' Feature.
 * @param {string} featureName The name of the feature.
 * @returns {import('@ngrx/store').MemoizedSelector<object, InformationData>} A
 * memoized selector that returns the 'DownloadStatementForm' feature state.
 * 
 * @const downloadStatementFormFeature
 */
export const downloadStatementFormFeature = createFeatureSelector<DownloadStatementFormOptions>('downloadStatementForm');

export const getDownloadStatementData = (data: DownloadStatementFormOptions): DownloadStatementFormOptions => data;

export const getDownloadStatementFormDataSelector = createSelector(
    downloadStatementFormFeature,
    getDownloadStatementData
);